import { msgTypes } from "constants/msgTypes";
import { Validation } from "constants/Validation";
import * as Yup from "yup";

export const CertificateSchema=

Yup.object({
    certificateId: Yup.string(),

    certificateName: Yup.string()//.required(Validation.required.message.replaceAll("^","Certificate Name"))
                      .matches(Validation.plaintext.regex , Validation.plaintext.message),
    expireDate: Yup.string().required(Validation.required.message.replaceAll("^","Certificate Expire Date")),
    
    companyId: Yup.string().required(Validation.required.message.replaceAll("^","Company Name")),

    pdf: Yup.string(),
    image: Yup.string(),

})